module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- src/app/commons/templates/Paginator.ejs -->\n';
 if (pagination.count > pagination.limit) { 
__p+='\n<ul class="pagination pull-right">\n    <li class="page-item '+
((__t=( pagination.page <= 0 ? 'disabled' : '' ))==null?'':_.escape(__t))+
'">\n        <a aria-label="Previous" class="js-pagination-prev">\n            <span aria-hidden="true">Previous</span>\n        </a>\n    </li>\n    ';
 _.times(pagination.pages, function(i) { 
__p+='\n    <li class="page-item '+
((__t=( pagination.page == i ? 'active' : '' ))==null?'':_.escape(__t))+
'">\n        <a aria-label="Page '+
((__t=( i + 1 ))==null?'':_.escape(__t))+
'" data-page="'+
((__t=( i ))==null?'':_.escape(__t))+
'"\n           class="js-pagination-page">\n            <span aria-hidden="true">'+
((__t=( i + 1 ))==null?'':_.escape(__t))+
'</span>\n        </a>\n    </li>\n    ';
 }) 
__p+='\n    <li class="page-item\n                    '+
((__t=( pagination.page >= (pagination.pages - 1) ? 'disabled' : '' ))==null?'':_.escape(__t))+
'">\n        <a aria-label="Next" class="js-pagination-next">\n            <span aria-hidden="true">Next</span>\n        </a>\n    </li>\n</ul>\n\n<span class="pull-right pagination-info">\n                Showing\n    '+
((__t=( pagination.offset + 1 ))==null?'':_.escape(__t))+
' to\n    '+
((__t=( Math.min(pagination.count, pagination.offset + pagination.limit) ))==null?'':_.escape(__t))+
'\n    of '+
((__t=( pagination.count ))==null?'':_.escape(__t))+
'\n    '+
((__t=( (items) ? items : 'items'  ))==null?'':_.escape(__t))+
'\n            </span>\n';
 } 
__p+='\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/commons/templates/Paginator.ejs
// module id = 669
// module chunks = 1